import currenciesService from '@/services/currencies';
import generalCatalogsService from '@/services/generalCatalogs';
import areasService from '@/services/areas';
import taxesService from '@/services/taxes';
import { normalizeCatalogOptions, normalizeCurrencyOptions } from '@/utils/catalogOptions';
import { extractCollection } from '@/utils/dataNormalization';

const toSafeString = (value) => String(value ?? '').trim();
const silentRequestConfig = {};

const normalizeTaxOptions = (items) => {
  return normalizeCatalogOptions(items, { useCodeInLabel: false });
};

const normalizeBasicSelectorOptions = (items) => {
  return normalizeCatalogOptions(items, { useCodeInLabel: false });
};

const normalizePaymentPeriodOptions = (items) => {
  return (Array.isArray(items) ? items : [])
    .map((item) => {
      const code = toSafeString(item?.code).toLowerCase();
      const name = toSafeString(item?.name);

      if (code === '' || name === '') {
        return null;
      }

      return {
        value: code,
        label: name,
        meta: {
          ...item,
          code,
          name,
        },
      };
    })
    .filter(Boolean);
};

export const fetchPaymentPlanModalCatalogs = async () => {
  const requests = [
    ['currencies', currenciesService.selectors({}, silentRequestConfig)],
    ['areas', areasService.index(silentRequestConfig)],
    ['taxes', taxesService.selectors({}, silentRequestConfig)],
    ['taxGroups', taxesService.groupSelectors({}, silentRequestConfig)],
    ['periodicities', generalCatalogsService.getPaymentPeriods(silentRequestConfig)],
  ];

  const results = await Promise.allSettled(requests.map(([, request]) => request));

  const collections = {};

  requests.forEach(([key], index) => {
    const result = results[index];
    collections[key] = result?.status === 'fulfilled'
      ? extractCollection(result.value)
      : [];
  });

  return {
    currencies: normalizeCurrencyOptions(collections.currencies),
    areas: normalizeBasicSelectorOptions(collections.areas),
    taxes: normalizeTaxOptions(collections.taxes),
    taxGroups: normalizeTaxOptions(collections.taxGroups),
    periodicities: normalizePaymentPeriodOptions(collections.periodicities),
  };
};
